var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiviologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 20,
    viewBox: "0 0 105 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3464 16.8369V2.16742H34.3881V7.98916H43.8171V2.16742H47.8588V16.8369H43.8171V10.9471H34.3881V16.8369H30.3464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0209 16.8369V2.16742H56.0626V16.8369H52.0209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5934 0H20.9437V3.17264H10.5934V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5934 6.32959H20.9437V9.50223H10.5934V6.32959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5934 12.6749H20.9437V15.8475H10.5934V12.6749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M63.9785 16.8369L58.162 2.16742H63.0361L68.4495 15.1826H68.7165L74.0513 2.16742H75.3707L69.1406 16.8369H63.9837H63.9785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.162 2.16742L63.9785 16.8369H69.1406L63.0361 2.16742H58.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.47 16.8369V2.16742H81.5117V16.8369H77.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2498 9.50221C85.2498 4.9265 88.9669 1.94757 94.9457 1.94757C100.925 1.94757 104.752 4.9265 104.752 9.50221C104.752 14.0779 101.061 17.0569 94.9457 17.0569C88.8308 17.0569 85.2498 14.0779 85.2498 9.50221ZM100.443 9.50221C100.443 6.24058 98.9089 5.09927 94.9457 5.09927C90.9826 5.09927 89.5323 6.23534 89.5323 9.50221C89.5323 12.7691 90.9878 13.9052 94.9457 13.9052C98.9037 13.9052 100.443 12.7691 100.443 9.50221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57249 6.34527C7.43122 6.34527 5.9182 5.76415 4.3633 4.34536L4.26382 4.25112C3.36334 3.43441 2.59374 3.15693 1.25872 3.15693H0.248291V0H1.25348C3.41569 0 4.98107 0.602068 6.49409 2.02085L6.55168 2.07321C7.49928 2.9161 8.24794 3.18834 9.57249 3.18834H10.5934L10.5986 6.34004H9.59867C9.59867 6.34004 9.58296 6.34004 9.57249 6.34004V6.34527Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57249 12.6748C7.43122 12.6748 5.9182 12.0937 4.3633 10.6749L4.26382 10.5807C3.36857 9.76395 2.59374 9.48647 1.25872 9.48647H0.248291V6.33478H1.25348C3.41569 6.33478 4.98107 6.93685 6.49409 8.35563L6.55168 8.40799C7.49928 9.25088 8.24794 9.52312 9.57249 9.52312H10.5934L10.5986 12.6748H9.59867C9.59867 12.6748 9.58296 12.6748 9.57249 12.6748Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57249 19.0044C7.43122 19.0044 5.9182 18.4233 4.3633 17.0045L4.26382 16.9103C3.36334 16.0935 2.59374 15.8161 1.25872 15.8161H0.248291V12.6644H1.25348C3.41569 12.6644 4.98107 13.2664 6.49409 14.6852L6.55168 14.7376C7.49928 15.5805 8.24794 15.8527 9.57249 15.8527H10.5934L10.5986 19.0044H9.59867C9.59867 19.0044 9.58296 19.0044 9.57249 19.0044Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.503,
    height: 19.0044,
    fill: "white",
    transform: "translate(0.248291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiviologo);
export default __webpack_public_path__ + "static/media/hiviologo.20a74e8de82df577bec1e0c37d46f2f5.svg";
export { ForwardRef as ReactComponent };